import React from "react";
import { User } from "@/api/users";
import {
  ApplicationCustomerUsers,
  removeApplicationCustomerUsers,
} from "@/api/customers";
import { Link } from "react-router-dom";
import { DataGrid, DataGridColumn } from "@/ui-controls/DataGrid";
import MoreActionsButton from "@/ui-controls/MoreActionsButton";

interface Props {
  AppId: number;
  CustomerId: number;
  UserList: User[];
  onRemoveUsers?: (userIds: number[]) => any;
}

const AppCustomerUserDetailList = (props: Props) => {
  const countBadgeStyle: React.CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 32,
    height: 28,
    padding: "0 10px",
    borderRadius: 14,
    backgroundColor: "#f3f2f1",
    color: "#323130",
    fontWeight: 600,
    textDecoration: "none",
  };

  const columns: DataGridColumn[] = [
    {
      key: "id",
      name: "Id",
      fieldName: "Id",
      minWidth: 50,
      maxWidth: 60,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "emailAddress",
      name: "EmailAddress",
      fieldName: "EmailAddress",
      minWidth: 150,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "NoRoles",
      name: "Roles",
      fieldName: "RolesCount",
      minWidth: 70,
      maxWidth: 100,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
      onRender: (item: User) => (
        <Link
          to={`/applications/${props.AppId}/customers/${props.CustomerId}/users/${item.Id}/roles`}
          style={countBadgeStyle}
        >
          {item.RolesCount}
        </Link>
      ),
    },
    {
      key: "Actions",
      name: "",
      minWidth: 50,
      maxWidth: 70,
      onRender: (item: User) => (
        <MoreActionsButton
          menu={[
            {
              key: "remove",
              text: "Remove user from customer",
              iconProps: { iconName: "Cancel" },
              onClick: () => {
                removeCustomerUsers(item);
              },
            },
          ]}
        />
      ),
    },
  ];

  const removeCustomerUsers = (user: User) => {
    removeApplicationCustomerUsers({
      AppId: props.AppId,
      CustomerId: props.CustomerId,
      UserIds: [user.Id],
    } as ApplicationCustomerUsers).then(
      (_) => {
        if (props.onRemoveUsers) props.onRemoveUsers([user.Id]);
      },
      (error) => {
        handleError(error);
      }
    );
  };

  const handleError = (error: Error) => {
    // Error handled by parent component
  };

  return (
    <>
      <DataGrid items={[...props.UserList]} columns={columns} />
    </>
  );
};

export default AppCustomerUserDetailList;
